export default __webpack_public_path__ + "static/media/visitsFull.4b40dcf9.png";